/**
 * SMG — Testimonials Stories Filter
 * Web Component: <smg-stories-filter>
 *
 * Handles tab filtering for testimonial cards.
 * - "all"   → muestra todas las cards
 * - "men"   → muestra solo cards con data-category="men"
 * - "women" → muestra solo cards con data-category="women"
 */
class SmgStoriesFilter extends HTMLElement {
  connectedCallback() {
    this._tabs = Array.from(this.querySelectorAll('[data-filter]'));

    const cardsSelector = this.dataset.cards;
    const cardsContainer = cardsSelector
      ? document.querySelector(cardsSelector)
      : this.closest('.smg-testimonials-stories');

    this._cards = cardsContainer
      ? Array.from(cardsContainer.querySelectorAll('[data-category]'))
      : [];

    // Store bound handlers for cleanup
    this._tabHandlers = [];
    this._tabs.forEach((tab) => {
      const handler = () => this._handleFilter(tab);
      this._tabHandlers.push({ tab, handler });
      tab.addEventListener('click', handler);
    });
  }

  disconnectedCallback() {
    // Cleanup tab click listeners
    if (this._tabHandlers) {
      this._tabHandlers.forEach(({ tab, handler }) => {
        tab.removeEventListener('click', handler);
      });
      this._tabHandlers = [];
    }
    this._tabs = [];
    this._cards = [];
  }

  _handleFilter(activeTab) {
    const filter = activeTab.dataset.filter;


    this._tabs.forEach((tab) => {
      const isActive = tab === activeTab;
      tab.classList.toggle('smg-testimonials-stories__filter-tab--active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    this._cards.forEach((card) => {
      if (filter === 'all') {
        card.hidden = false;
      } else {
        card.hidden = card.dataset.category !== filter;
      }
    });
  }
}

customElements.define('smg-stories-filter', SmgStoriesFilter);
